import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { Layout } from "./Layout";
import { UserRole } from "../../model/UserRole";

/**
 * Composant ayant plusieurs utilités:
 * - Vérifier si l'utilisateur est connecté (ou redirection vers la page de login)
 * Afficher le composant Layout
 * @returns
 */
const PrivateRoute = () => {
  const auth = useAuth();
  const location = useLocation();

  // if the user is not connected, redirect to login
  if (!auth.token) {
    return <Navigate to="/login" />;
  }
  // admin routes
  const adminOnlyRoutes = ["/users", "/export"];
  // check if the route is reserved to admins
  const isAdminRoute = adminOnlyRoutes.some(
    (route) => location.pathname === route || location.pathname.startsWith(`${route}/`)
  );
  // checks if the user is not an admin but tries to access an admin path.
  if (isAdminRoute && !auth.roles.includes(UserRole.ADMIN)) {
    return <Navigate to="/unauthorized" />;
  }
  return (
    <>
      <Layout />
    </>
  );
};

export default PrivateRoute;
